import { Injectable } from '@angular/core';
import { QuoteService } from 'src/app/service/quote.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteComponentService {

currentStep: number = 1;
id: number = 1;
/** Paso mas avanzado que el usuario ha alcanzado: las bolitas del indicador solo llevan a pasos ya alcanzados */
maxStep: number = 1;
constructor(private quoteService: QuoteService) { }

	nextStep(step: number = 0): void {
		if(step !== 0){
			this.currentStep = step
			if (step > this.maxStep) { this.maxStep = step }
			return
		}
		if (this.currentStep < 12){
			this.currentStep += 1;
			if(this.currentStep == 5){
			this.currentStep += 2;
			}      
		} 
		if (this.currentStep > this.maxStep) { this.maxStep = this.currentStep }
	}

	prevStep(step: number = 0): void {
		if(this.currentStep === 11) {
			if(this.quoteService.quoteModel.dependentCount === 0 && this.quoteService.quoteModel.dependentCountOver65 === null) {
				this.currentStep = 9
				return
			}
		}
		if(step !== 0){
			this.currentStep = step
			return
		}
		// Sin llaves, el if solo protegia la linea siguiente y desde el paso 1 se caia al paso 0 ("cargar cotizacion")
		if (this.currentStep > 1) {
			if(this.currentStep == 2){
				this.quoteService.fromStepTwoTrue()
			}
			this.currentStep -= 1;
			if(this.currentStep == 6){
				this.currentStep -= 2;
			}
		}
	}

	setCurrentStepValue(value: number){
		this.currentStep = value
		if (value > this.maxStep) { this.maxStep = value }
	}

	/** Indicador de pasos: Cotizar -> 1 (siempre), Customizar -> 4 (si ya hubo cotizacion), Pagar -> 7 (si ya se eligio plan). Devuelve si navego. */
	goToStep(target: number): boolean {
		if (target === this.currentStep) { return false }
		if (target === 1 || this.maxStep >= target) {
			this.currentStep = target
			return true
		}
		return false
	}

	setIdValue(value: number){
		this.id = value
	}
}
